import { DELETE_GEOFENCE, SAVE_GEOFENCE, SAVE_GEOFENCE_DEVICES, SET_DETAILED_GEOFENCE } from '../constants/geofence.constants';

export const setDetailedGeofence = geofence => ({ type: SET_DETAILED_GEOFENCE, geofence });
export const deleteGeofence = geofence => ({ type: DELETE_GEOFENCE, geofence });
export const saveGeofence = geofence => ({ type: SAVE_GEOFENCE, geofence});
export const saveGeofenceDevices = (geofence, devices, teamIds) => ({ type: SAVE_GEOFENCE_DEVICES, geofence, devices, teamIds });